import { render, staticRenderFns } from "./scroll.vue?vue&type=template&id=98585d16&scoped=true&"
import script from "./scroll.vue?vue&type=script&lang=js&"
export * from "./scroll.vue?vue&type=script&lang=js&"
import style0 from "./main.css?vue&type=style&index=0&id=98585d16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98585d16",
  null
  
)

export default component.exports